/**
 * unifiedAuthService.js — Backward-compatibility shim
 *
 * The old multi-call approach (checkAuthorization + getIntegrationStatus)
 * is replaced by a single GET /api/users/me/full call via meService.
 *
 * All old exports are kept here so existing component imports don't break,
 * but they now delegate to meService.
 */
import { getMe, invalidateMe } from './meService';

export const invalidateAuthCache = invalidateMe;

export const quickAuthCheck = async () => {
  const me = await getMe();
  return {
    is_authorized: true, // Keycloak-authenticated = authorized
    is_admin: !!me.is_admin,
    is_configured: !!me.has_integration,
    tenant_name: me.integration?.tenant_name ?? null,
    domain: me.integration?.domain ?? null,
  };
};

export const getFreshUnifiedStatus = async (options = {}) => {
  const me = await getMe({ forceRefresh: true });
  return {
    is_authorized: true,
    is_admin: !!me.is_admin,
    is_configured: !!me.has_integration,
    tenant_name: me.integration?.tenant_name ?? null,
    domain: me.integration?.domain ?? null,
    integration: me.integration ?? null,
    has_integration: !!me.has_integration,
    email: me.email,
    fetched_at: me.fetched_at,
  };
};

export const getUnifiedStatus = async (options = {}) => {
  const { forceRefresh = false } = options;
  const me = await getMe({ forceRefresh });
  return {
    is_authorized: true,
    is_admin: !!me.is_admin,
    is_configured: !!me.has_integration,
    tenant_name: me.integration?.tenant_name ?? null,
    domain: me.integration?.domain ?? null,
    integration: me.integration ?? null,
    has_integration: !!me.has_integration,
    email: me.email,
    fetched_at: me.fetched_at,
  };
};

export const checkAuthorizationOnly = async () => {
  return quickAuthCheck();
};

export const getIntegrationStatusOnly = async (_email, { forceRefresh = false } = {}) => {
  const me = await getMe({ forceRefresh });
  return me.integration ?? null;
};

export const getIntegrationWithAuth = async (_email) => {
  const me = await getMe();
  return {
    is_authorized: true,
    is_admin: !!me.is_admin,
    tenant_name: me.integration?.tenant_name ?? null,
    domain: me.integration?.domain ?? null,
    integration: me.integration ?? null,
    has_integration: !!me.has_integration,
  };
};

// Backward compat aliases
export const checkAuthorization = quickAuthCheck;
export const getStatus = getIntegrationStatusOnly;